import { render, staticRenderFns } from "./PaymentManageView.vue?vue&type=template&id=c28fed0a&scoped=true&"
import script from "./PaymentManageView.vue?vue&type=script&lang=js&"
export * from "./PaymentManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28fed0a",
  null
  
)

export default component.exports